module.exports = __webpack_public_path__ + "img/制御工学3_4.b1377d06.png";